import React, { Context } from 'react';

import { ForcedLanguageTranslationContextType } from '../types/forcedLanguageTranslationContextType.types';

export const ForcedLanguageTranslationContext: Context<ForcedLanguageTranslationContextType>
  = React.createContext({} as ForcedLanguageTranslationContextType);
